import React, { useEffect, useState } from 'react'
import { Form, Button,Row, Col } from 'react-bootstrap'
import {useSubmit, useActionData } from 'react-router-dom'
import Input from './Input'
import Alert from './Alert'
import { on_login } from '../api';
import { convert_to_json, check_validity} from '../utils/utils'
import { 
    create as create_auth,
    get_redirect_after_authenticate_cache,
    remove_redirect_after_authenticate_cache
} from '../module/auth'

const button_style = { "width" : "100%" };

export const action = async({ request, params }) =>{

    try{

        const formData = await request.formData();
        const data = convert_to_json(formData);

        const response = await on_login(data);
        return response;
    }
    catch(exeption){
        return exeption
    }

}

function FormLogin(props) {

    const response = useActionData();
    let submit = useSubmit();

    const [message,set_message] = useState({ show : undefined, variant : undefined, message : undefined });
    const [login,set_login] = useState( { email: { value: "", valid : false }, password: { value:"", valid:false } });

    const handle_change = (e,valid) => {

        const input = e.target;

        set_login(priv_login =>{
            return {
                ...priv_login,
                [input.name] : { value: input.value, valid: valid},
            }
        });
    }

    const handle_submit = (event) =>{

        const form = event.currentTarget;
       
        event.preventDefault();
        event.stopPropagation();

        if (form.checkValidity() && check_validity(login)) {
           submit(form,{method:"POST"});
        }

    }

    useEffect(()=>{

        // console.log(response);
        if(response !== undefined){
            
            // console.log(response);
             //SUCCESS...
             if(response.status >=200 && response.status < 300){
        
                create_auth(response);

                const redirec_to = get_redirect_after_authenticate_cache();
                if(redirec_to !== null){

                    remove_redirect_after_authenticate_cache();
                    window.location.href = redirec_to;
                }
                else{
                    window.location.reload();
                }
                
                return;
            }

            //BAD_REQUEST.....
            if(response.status >=400 && response.status < 500){
                
                
                set_message({
                    ...message,
                    show:true,
                    message : response.message,
                    variant: "Danger"
                });

                if(response.validations !== undefined){
                    response.validations.forEach(validation => {
                        const index = login.findIndex(x=> x.name === validation.name);
                        set_login(index,["isInvalid","message"],[true,validation.message]);
                        
                    });
                }

                return;
            }

            //ERROR_SERVER...
            if(response.status >=500 && response.status < 600){
                
                set_message({
                    show:true,
                    message : "Ocurrio un error en el servidor.",
                    variant: "Danger"
                });

                return;
            }
        }
        // eslint-disable-next-line
    },[response]);

    useEffect(()=>{ 
        
        if(response === undefined){
            if(props.message !== undefined) set_message(props.message); 
        }
    // eslint-disable-next-line
    },[props]);


  return (
   <>
     <Form onSubmit={handle_submit}>
        <Form.Group className="m-4">
            <Input 
                key             = { 'email' } 
                id              = { `txtemail` }
                name            = { 'email' } 
                type            = { 'email' }
                label           = { 'Correo electrónico' } 
                placeholder     = { 'Ingrese su correo electrónico' } 
                required        = { true } 
                message         = { login.email.message }
                onChange        = { handle_change }
            />
        </Form.Group>
        <Form.Group className="m-4">
            <Input 
                key             = { 'password' } 
                id              = { `txtpassword` }
                name            = { 'password' } 
                type            = { 'password' }
                label           = { 'Contraseña' } 
                placeholder     = { 'Ingrese su contraseña' } 
                required        = { true } 
                message         = { login.password.message }
                onChange        = { handle_change }
            />
        </Form.Group>

        <Alert show={message.show} variant={message.variant} message={message.message} />

        <Row>
            <Col>
                <Form.Group className='m-4'>
                    <Button type='submit' variant="primary"  style={button_style}>Entrar</Button>
                </Form.Group>  
            </Col>
        </Row>
     </Form>
   </>
  )
}

export default FormLogin